// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1pJh5","inner":"Footer_inner__2-u6s","nextIcon":"Footer_nextIcon___Z9ES","innerLeft":"Footer_innerLeft__3yzOO"};